var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { transform: "rotate(180 8 8)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M2.19646 5.19614C2.45843 4.93415 2.88319 4.93413 3.14519 5.1961L8.03763 10.0881L12.9301 5.1961C13.1921 4.93413 13.6168 4.93415 13.8788 5.19614C14.1408 5.45814 14.1407 5.88289 13.8788 6.14486L8.76517 11.258C8.76516 11.258 8.76517 11.258 8.76517 11.258C8.66968 11.3536 8.55626 11.4295 8.43143 11.4812C8.30659 11.533 8.17277 11.5596 8.03763 11.5596C7.90249 11.5596 7.76867 11.533 7.64383 11.4812C7.51901 11.4295 7.40561 11.3536 7.31012 11.258C7.31011 11.258 7.31013 11.258 7.31012 11.258L2.19651 6.14486C1.93451 5.88289 1.93449 5.45814 2.19646 5.19614Z",
            fill: "#472B88",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }